// removed by extract-text-webpack-plugin
module.exports = {"bar-graph":"finance_bar-graph_x","bg":"finance_bar-graph_bg","bars":"finance_bar-graph_bars","barGroup":"finance_bar-graph_barGroup","bar":"finance_bar-graph_bar","value":"finance_bar-graph_value","outside":"finance_bar-graph_outside","inside":"finance_bar-graph_inside","label":"finance_bar-graph_label","positive":"finance_bar-graph_positive","negative":"finance_bar-graph_negative"};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cube/finance-components/src/components/bar-graph/style.less
// module id = 1056
// module chunks = 0